import { Route } from '@angular/router';

export const contentRoutes: Route[] = [
  {
    path: 'content',
    children: [
      {
        path: '',
        loadComponent: () => import('../pages/content/content.page'),
      },
      {
        path: ':id',
        loadComponent: () =>
          import('../pages/content/content-detail/content-detail.page'),
      },
    ],
  },
];
